/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Intro_P1Inputs */

const es_marketplace_seo_galicia_guide_intro_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galicia concentra algunas de las mejores rutas náuticas del Atlántico: rías profundas, islas protegidas y gastronomía marinera a bordo. En Zarpar encuentras alquileres y experiencias desde Vigo, Pontevedra, Sanxenxo, A Coruña y otros puertos de la comunidad.`)
};

const gl_marketplace_seo_galicia_guide_intro_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galicia concentra algunhas das mellores rutas náuticas do Atlántico: rías profundas, illas protexidas e gastronomía mariñeira a bordo. En Zarpar atopas alugueiros e experiencias dende Vigo, Pontevedra, Sanxenxo, A Coruña e outros portos da comunidade.`)
};

const en_marketplace_seo_galicia_guide_intro_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galicia offers some of the Atlantic's finest boating: deep rias, protected islands and onboard seafood. On Zarpar you will find rentals and experiences from Vigo, Pontevedra, Sanxenxo, A Coruña and other ports.`)
};

/**
* | output |
* | --- |
* | "Galicia offers some of the Atlantic's finest boating: deep rias, protected islands and onboard seafood. On Zarpar you will find rentals and experiences from ..." |
*
* @param {Marketplace_Seo_Galicia_Guide_Intro_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_intro_p1 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Intro_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Intro_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_intro_p1(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_intro_p1(inputs)
	return es_marketplace_seo_galicia_guide_intro_p1(inputs)
});